import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import {apiUrl} from'../Config/Config';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      membershiplist:'',
      domainlist:[],
    };
    


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };  

      axios.post(apiUrl+"insurance/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  membershiplist: res.data.membershiplist, totalRecord: res.data.records_count}, function() {
            
              this.membershiplist();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getmembershiplist(qs.stringify(postobject))
    axios.post(apiUrl+"insurance/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  membershiplist: res.data.membershiplist, totalRecord: res.data.records_count}, function() {
            this.membershiplist();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  axios.post(apiUrl+"insurance/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  membershiplist: res.data.membershiplist, totalRecord: res.data.records_count}, function() {
          this.membershiplist();
        });

    }
  }); 

} 


deleteConfirm=(confirmstatus,id)=>{
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id  :id
    };

  axios.post(apiUrl+"insurance/delete",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){   
      $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');

      setTimeout(
      function() {
        $('.success_message').html('');
        window.location.reload(); 
      }
      .bind(this),
      3000
      );    
        
    }
  }); 
}else{
  $('.confirm-action-delete').removeClass('show');	
}
}

activemembership(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

        if(stat == "A"){
          axios.post(apiUrl+"insurance/checkBeforeChange",qs.stringify(postObject)).then(res => {
            if(res.data.status === 'success'){
              this.change_status(postObject);
            }else{
              $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
              setTimeout(
              function() {
                $('.success_message').html('');
              }
              .bind(this),
              3000
              );
            }
          });
        }else{
          this.change_status(postObject);
        }
      
}

change_status(postObject){
  var qs = require('qs');
  axios.post(apiUrl+"insurance/change_status",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){
      window.location.reload(false);
    }
  }); 
}


membershiplist() {
  let catImg = '';
  let preview = '';
    var membershiplist = this.state.membershiplist;
    if (membershiplist != "undefined" && membershiplist != null) {
      console.log(membershiplist);
    
      if (membershiplist.length > 0) {

        if (Object.keys(membershiplist).length > 0) {
          const helperlistDetails = membershiplist.map(
            (membershiplist, Index) => {
              let sno = Index+1;
              

               if(membershiplist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
             
              return (
                <tr key={membershiplist.membership_id}>
      					<td>{sno}</td>
      					<td>{membershiplist.membership_name}</td>
      					{/* <td>{membershiplist.description}</td> */}
                <td>${membershiplist.amount}</td>
      					<td>{(membershiplist.period ? membershiplist.period + "ly" : "")}</td>
                <td>{status}</td>
                <td className="actiongroup" >
                    
                    
                     <Link to={{ pathname: '/insurance-view/'+membershiplist.membership_id}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link>
                    <Link to={{ pathname: '/insurance-edit/'+membershiplist.membership_id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activemembership.bind(this, membershiplist.membership_id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activemembership.bind(this, membershiplist.membership_id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      

                   

                     <Link onClick={this.deletememebership.bind(this,membershiplist.membership_id)} className="" title="Delete"><i className="ft-trash-2" aria-hidden="true"></i></Link>
                    
                     
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  
  deletememebership(id){
    this.setState({rowid : id})
    $('.confirm-action-delete-message').html('Are you sure delete the Insurance?');	
    $('.confirm-action-delete').addClass('show');	
  }

  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper">  
    <Header />
    <MenuSidebar currentpage="Insurance" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>   
         <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.totalRecord > 0?this.state.totalRecord:''} Membership{this.state.totalRecord>1 ? 's' : ''} </h3>
                </div>
               

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/insurance-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Name</th>
                  {/* <th>Description</th> */}
                  <th>Amount</th>
                  <th>Period</th>
                  <th>Status</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.membershiplist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
            <p className="confirm-action-delete-message"></p>
            <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.rowid)} className="btn">Yes</a>
            <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
            <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
          </div>
    </div>
    );
  }
}
export default (withRouter(List));